import * as React from 'react';

import IconCollectionsBolt from './IconCollectionsBolt';

export const collectionsBolt = () => <IconCollectionsBolt />;

export default {
    title: 'Icons/Collections/Bolt',
    component: IconCollectionsBolt,
    parameters: {
        notes: "`import IconCollectionsBolt from 'box-ui-elements/es/icons/collection/IconCollectionsBolt';`",
    },
};
